import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { Container, Spinner } from "@/components/shared";
import { FicheContent, ShareBar } from "@/components/RightsFiche";
import { UserPlus } from "lucide-react";
import Seo from "@/components/Seo";

export default function PublicRight() {
  const { slug } = useParams();
  const [sheet, setSheet] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setSheet(null); setError(false);
    axios.get(`${API}/public/rights/${slug}`).then(({ data }) => setSheet(data)).catch(() => setError(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      {sheet && <Seo title={`${sheet.title} — BIZARRE AI`} description={sheet.summary} path={`/f/${slug}`} />}
      <header className="border-b border-white/10">
        <div className="max-w-5xl mx-auto px-5 md:px-10 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg gold-gradient flex items-center justify-center">
              <span className="text-black font-bold text-xs font-display">B</span>
            </div>
            <span className="font-display tracking-tight">BIZARRE <span className="gold-text">AI</span></span>
          </Link>
          <Link to="/login" data-testid="public-login-link" className="text-sm text-gold hover:underline">Se connecter</Link>
        </div>
      </header>

      {error && <Container><p className="text-white/60">Fiche introuvable.</p></Container>}
      {!error && !sheet && <Container><Spinner label="Chargement de la fiche..." /></Container>}
      {sheet && (
        <Container>
          <p className="text-gold text-xs uppercase tracking-[0.2em] mb-3">Connaître vos droits · {sheet.category}</p>
          <h1 className="font-display text-3xl md:text-4xl tracking-tight font-light" data-testid="public-rights-title">{sheet.title}</h1>
          <p className="text-white/70 mt-3 max-w-2xl leading-relaxed">{sheet.summary}</p>
          <div className="my-6"><ShareBar slug={sheet.slug} title={sheet.title} summary={sheet.summary} /></div>
          <FicheContent sheet={sheet} publicMode />

          <div data-testid="public-signup-cta" className="mt-8 rounded-2xl border border-gold/30 bg-gradient-to-br from-[#BF953F]/15 to-transparent p-6 text-center">
            <h3 className="font-display text-xl mb-2">Allez plus loin gratuitement</h3>
            <p className="text-white/60 text-sm max-w-md mx-auto mb-4">
              Créez un compte pour utiliser l'assistant IA, tester vos connaissances, générer des courriers et préparer votre dossier de preuves.
            </p>
            <Link to="/login" data-testid="public-signup-button"
              className="inline-flex items-center gap-2 gold-gradient text-black rounded-full px-6 py-2.5 font-medium hover:opacity-90 transition-opacity">
              <UserPlus size={18} /> Créer un compte gratuitement
            </Link>
          </div>
        </Container>
      )}
    </div>
  );
}
